const AI_CHATBOT_READY_EVENT = 'aida:ready';
const AI_CHATBOT_TAG_NAME = 'aida-companion';

interface AiChatbotElement extends HTMLElement {
    startConversation: (prompt?: string) => Promise<boolean>;
}

function getAiChatbotElement(): AiChatbotElement | null {
    const element = document.querySelector(AI_CHATBOT_TAG_NAME) as Partial<AiChatbotElement> | null;
    return element && typeof element.startConversation === 'function' ? element as AiChatbotElement : null;
}

export const AiChatbotService = {
    isReady(): boolean {
        return getAiChatbotElement() !== null;
    },

    // Notifie l'état de l'API du chatbot (true: prête, false: retirée du DOM) et retourne la fonction de désabonnement
    onReadyChange(callback: (isReady: boolean) => void): () => void {
        const listener = (event: Event) => callback((event as CustomEvent<boolean>).detail === true);
        window.addEventListener(AI_CHATBOT_READY_EVENT, listener);
        return () => window.removeEventListener(AI_CHATBOT_READY_EVENT, listener);
    },

    async startConversation(prompt?: string): Promise<boolean> {
        const chatbot = getAiChatbotElement();
        if (!chatbot) {
            return false;
        }
        return chatbot.startConversation(prompt);
    },
};
